import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FieldError, FieldValues, UseFormRegister } from "react-hook-form";
import clsx from "clsx";

interface Props {
  radio?: boolean;
  label: React.ReactNode;
  labelClasses?: string;
  id: string;
  name: string;
  value: string | number;
  checked?: boolean;
  error?: FieldError;
  className?: string;
  defaultChecked?: boolean;
}

export const WCheckbox = React.forwardRef<
  HTMLInputElement,
  Props & ReturnType<UseFormRegister<FieldValues>>
>((props, ref) => {
  const {
    onChange,
    onBlur,
    name,
    radio = false,
    label,
    labelClasses = "text-sm font-normal",
    id,
    value,
    error,
    className,
    checked,
    disabled
  } = props;

  const type = radio ? "radio" : "checkbox";

  return (
    <div
      className={clsx([
        "w-full",
        radio ? "ek-checkbox-round" : "ek-checkbox-square",
        className
      ])}
    >
      <div className="relative flex items-center justify-center">
        <input
          type={type}
          name={name}
          id={id}
          className={clsx([error && error.type && "error-input"])}
          value={value}
          ref={ref}
          onChange={onChange}
          onBlur={onBlur}
          checked={checked}
          defaultChecked={props.defaultChecked}
          disabled={disabled}
        ></input>
        <FontAwesomeIcon icon={faCheck} />
      </div>
      <label
        htmlFor={id}
        className={clsx(
          labelClasses,
          {
            "input-error-text": error && error.type
          },
          disabled && "opacity-30 cursor-not-allowed"
        )}
      >
        {label}
      </label>
    </div>
  );
});

WCheckbox.displayName = "Checkbox";

export default WCheckbox;
